/** Pure helpers for the folder browser (Workspace-relative POSIX paths inside an approved Workspace). */
export const joinFolder = (dir: string, name: string): string => (dir ? `${dir}/${name}` : name);

export const parentFolder = (p: string): string => (p.includes("/") ? p.slice(0, p.lastIndexOf("/")) : "");

/** Breadcrumb segments: "a/b" → [{label:"a",path:"a"},{label:"b",path:"a/b"}]. */
export const crumbs = (p: string): { label: string; path: string }[] =>
  p === "" ? [] : p.split("/").map((label, i, all) => ({ label, path: all.slice(0, i + 1).join("/") }));

/** Cheap client-side check that mirrors the agent's rules, so errors show before a round trip. The agent decides. */
export function projectNameError(name: string): string | null {
  const n = name.trim();
  if (n === "") return "Enter a name.";
  if (n.length > 255) return "That name is too long.";
  if (n === "." || n === ".." || n === ".git") return `"${n}" is a reserved name.`;
  // eslint-disable-next-line no-control-regex
  if (/[\u0000-\u001f\u007f/\\:]/.test(n)) return "Names cannot contain / \\ : or control characters.";
  if (n.endsWith(".")) return "Names cannot end with a dot.";
  return null;
}
